import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useMemo } from "react";
import katex from "../../../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
/* empty css                                                                             */
import { cn } from "../../../lib/utils.js";
function KaTeX({ math, className, displayMode = false }) {
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current && math) {
      try {
        katex.render(math, containerRef.current, {
          throwOnError: false,
          displayMode
        });
      } catch (error) {
        console.error("KaTeX render error:", error);
        if (containerRef.current) {
          containerRef.current.textContent = math;
        }
      }
    }
  }, [math, displayMode]);
  return /* @__PURE__ */ jsx("span", { ref: containerRef, className: cn("katex-text", className) });
}
function escapeText(t) {
  return t.replace(/＝/g, "=").replace(/－/g, "-").replace(/＋/g, "+").replace(/𝑚/g, "m").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"');
}
function TextWithLineBreaks({ text }) {
  const lines = text.split("\n");
  return /* @__PURE__ */ jsx(Fragment, { children: lines.map((line, idx) => /* @__PURE__ */ jsxs("span", { children: [
    line,
    idx < lines.length - 1 && /* @__PURE__ */ jsx("br", {})
  ] }, idx)) });
}
function KatexText({ text, className }) {
  const rendered = useMemo(() => {
    if (!text) return null;
    const _t = text.normalize ? text.normalize("NFC") : text;
    const katexReg = /\$\$([^$]+)\$\$/gim;
    const parts = [];
    let lastIndex = 0;
    let match;
    let idx = 0;
    while ((match = katexReg.exec(_t)) !== null) {
      if (match.index > lastIndex) {
        const textContent = _t.slice(lastIndex, match.index);
        parts.push({
          type: "text",
          content: escapeText(textContent),
          key: `text-${idx++}`
        });
      }
      parts.push({
        type: "math",
        content: match[1],
        key: `math-${idx++}`
      });
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < _t.length) {
      parts.push({
        type: "text",
        content: escapeText(_t.slice(lastIndex)),
        key: `text-${idx++}`
      });
    }
    return parts;
  }, [text]);
  if (!rendered || rendered.length === 0) {
    return /* @__PURE__ */ jsx("span", { className, children: text });
  }
  return /* @__PURE__ */ jsx("span", { className: cn("leading-relaxed", className), children: rendered.map((part) => {
    if (part.type === "math") {
      return /* @__PURE__ */ jsx(KaTeX, { math: part.content }, part.key);
    }
    return /* @__PURE__ */ jsx(TextWithLineBreaks, { text: part.content }, part.key);
  }) });
}
export {
  KaTeX,
  KatexText
};
//# sourceMappingURL=katex-text.js.map
